import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">页面未找到</h1>
        <p className="text-sm text-foreground-400 font-mono mb-2">{location.pathname}</p>
        <p className="text-foreground-500 mb-6">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-block px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}